module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "cf-pro-form-settings"
    }
  }, [(_vm.connected) ? _c('div', [_c('form-setting', {
    attrs: {
      "form": _vm.form,
      "layouts": _vm.layouts
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.connected) ? _c('div', [_c('link-keys')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cf-pro-alert-wrap"
    }
  }, [_c('status', {
    attrs: {
      "message": _vm.mainAlert.message,
      "success": _vm.mainAlert.success,
      "show": _vm.mainAlert.show
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b88b150"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Tab.vue
// module id = 225
// module chunks = 1